// Canonical measure wheel colors from onboarding
// Keyed by measure name for reliable lookup regardless of DB measure IDs
export const MEASURE_WHEEL_COLORS: Record<string, string> = {
  "Developmental Orientation": "#FCD26B",
  "Dependability": "#F9F26B",
  "Innovation": "#F6FFC2",
  "Creative Decisiveness": "#B3FFB3",
  "Creative Flexibility": "#89F7A6",
  "Workplace Engagement": "#94FFD8",
  "People Centrism": "#8FF9D8",
  "Communication": "#9CFFFA",
  "Empathetic Communication": "#99F1FF",
  "Collaboration": "#83E2FF",
  "Team Orientation": "#66D4FF",
  "Conflict Approach": "#66C1FF",
  "Conflict Response": "#66B3FF",
  "Conflict Management": "#66A4FF",
  "Emotional Resilience": "#6699FF",
  "Breadth of Approach": "#6683FF",
  "Resource Management": "#5D71ED",
  "Crisis Preparedness": "#5B5BEF",
  "Crisis Response": "#7B5AF2",
  "Crisis Recovery": "#9458F4",
  "Task Management": "#B157F7",
  "Information Management": "#D263FC",
  "Strategic Quantitative Reasoning": "#E566FF",
  "Strategic Thinking": "#FF66C5",
  "Advanced Strategy": "#FF6695",
  "Productivity": "#EF5B94",
  "Proactivity": "#FF5572",
  "Initiative": "#FF7757",
  "Goal Orientation": "#FF9364",
  "Goal Management": "#F9B26B",
}

export const DEFAULT_MEASURE_COLOR = "#6699FF"

/** Get the canonical wheel color for a measure, falling back to DB color or default */
export const getMeasureColor = (measureName: string, dbColor?: string | null): string => {
  return MEASURE_WHEEL_COLORS[measureName] || dbColor || DEFAULT_MEASURE_COLOR
}
